import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MenuAsideService } from 'src/app/core/_base/layout';
import { LiveSupportService } from 'src/app/provider/live-support.service';

@Component({
  selector: 'kt-live-support',
  templateUrl: './live-support.component.html',
  styleUrls: ['./live-support.component.scss']
})
export class LiveSupportComponent implements OnInit {

  guestVisible = JSON.parse(localStorage.getItem('token_form')).guest_visible;

  chatVisible = false;
  selectedProfileId: number = null;

  constructor(
    public supportServ: LiveSupportService,
    private changeDetect: ChangeDetectorRef,
    private menuAsideService: MenuAsideService,
  ) { }

  async ngOnInit() {
    this.menuAsideService.pathname$.next(window.location.pathname);
    try {
      await this.supportServ.getChats();
    } catch { }

    this.changeDetect.detectChanges();
  }

}
